export default __webpack_public_path__ + "static/media/advanced_sql.ce39ce8c.svg";